{
  "version": 1,
  "asset_id": "c15bbe7b-c556-455e-a155-08c4b298001c",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/c15bbe7b-c556-455e-a155-08c4b298001c/deliverables-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/c15bbe7b-c556-455e-a155-08c4b298001c/deliverables-640.avif",
  "original_filename": "deliverables-640.avif",
  "size": 16289,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:51Z"
}
